import * as firebase from 'firebase';
import 'firebase/firestore';
import 'firebase/storage';

const firebaseApp = firebase.initializeApp({
	apiKey: 'AIzaSyC7b8p34FeMwzhl9Hr3rIrB0INCDetRnfI',
	authDomain: 'barbershopagadir.firebaseapp.com',
	databaseURL: 'https://barbershopagadir.firebaseio.com',
	projectId: 'barbershopagadir',
	storageBucket: 'barbershopagadir.appspot.com',
	messagingSenderId: '93520066101',
	appId: '1:93520066101:web:2f0909879150eeea83e37c',
	measurementId: 'G-4C1DF4PKQW',
});

const db = firebaseApp.firestore();
const fb = firebaseApp;
export { fb, db };
